var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],class:[
    'leaflet-control-zoom leaflet-bar leaflet-control m-0 mt-2 enlarge-button',
    { 'leaflet-control--active': _vm.isVisible },
  ],attrs:{"title":_vm.$t('showDeliveryAreas')}},[_c('a',{on:{"click":_vm.toggleVisibility}},[(_vm.loading)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('i',{staticClass:"fas fa-draw-polygon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }